/* ----------------------------------------------------------------
   Trinity CRO — July 2026
   Desktop hover-to-open header dropdowns (Mandie-greenlit quick win,
   audit takeaway 4.1). The theme's nav <details> elements open on click
   only; this opens them on hover for mouse users. Touch and keyboard
   behaviour are untouched (guarded by hover/pointer media queries), and
   click continues to work as before.
   ---------------------------------------------------------------- */
(function () {
  var desktop = window.matchMedia('(min-width: 990px)');
  var mouse = window.matchMedia('(hover: hover) and (pointer: fine)');
  var CLOSE_DELAY_MS = 250;

  function init() {
    var menus = document.querySelectorAll('.header__inline-menu header-menu > details');
    if (!menus.length) return;

    menus.forEach(function (details) {
      var timer = null;
      var summary = details.querySelector(':scope > summary');

      details.addEventListener('mouseenter', function () {
        if (!desktop.matches || !mouse.matches) return;
        window.clearTimeout(timer);
        menus.forEach(function (other) {
          if (other !== details && other.hasAttribute('open')) {
            other.removeAttribute('open');
            var s = other.querySelector(':scope > summary');
            if (s) s.setAttribute('aria-expanded', 'false');
          }
        });
        if (!details.hasAttribute('open')) {
          details.setAttribute('open', '');
          if (summary) summary.setAttribute('aria-expanded', 'true');
        }
      });

      details.addEventListener('mouseleave', function () {
        if (!desktop.matches || !mouse.matches) return;
        window.clearTimeout(timer);
        timer = window.setTimeout(function () {
          details.removeAttribute('open');
          if (summary) summary.setAttribute('aria-expanded', 'false');
        }, CLOSE_DELAY_MS);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
